import type { UserInformation } from './user/types'
import type { AuthStateType } from './types'

import { useAuthStore, isAuthState } from './store'

// Naming is hard, and we ideally shouldn't expose the whole thing as a god object anyways.
const getState = () => useAuthStore.getState()

export * from './user/functions'
export * from './preferences/functions'

export const getAuthState = () => getState().state

export const getAuthActions = () => {
    const { update, logout } = getState();
    return { update, logout };
}

export const getAuthStateIs = (
    targets: AuthStateType[],
    state = getAuthState(),
) => isAuthState(state, targets)

export const authUpdate = (data: UserInformation) => {
    getState().update(data)
}

export const authLogout = () => {
    getState().logout()
}

export const onLoginRequest = () => {
    getState().onLoginRequest()
}

export const onLoginSuccess = (data: UserInformation) => {
    getState().onLoginSuccess(data)
}

export const onLoginFailure = (error: string | Error) => {
    getState().onLoginFailure(error)
}
